import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import "./App.css";

const App = () => {
  return (
    <div className="container">
      <header>
        <h1>Dr. Carlos Oliveira</h1>
        <p>Especialista em Direito Civil, Trabalhista e Direito Penal</p>
      </header>

      <main>
        <section className="about">
          <h2>Sobre Mim</h2>
          <p>
            Com mais de 20 anos de experiência, atuo na defesa dos direitos dos
            meus clientes com dedicação e ética.
          </p>
        </section>

        <section className="contact">
          <h2>Entre em Contato</h2>
          <p>
            Para consultas ou mais informações, entre em contato pelo WhatsApp
            ou acesse minhas redes sociais.
          </p>
          <div className="social-links">
            <a
              href="https://wa.me/5585988807062"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp"
            >
              <FaWhatsapp /> WhatsApp
            </a>
            <a
              href="https://www.instagram.com/consultoriaadvcarlos"
              target="_blank"
              rel="noopener noreferrer"
              className="instagram"
            >
              <FaInstagram /> Instagram
            </a>
            
          </div>
        </section>
      </main>

      <footer>
        <p>&copy; 2025 JCO Consultoria. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
};

export default App;
